import { defaultParseSearch, defaultStringifySearch } from '@tanstack/react-router';

// Email links carry these as plain text; the default parser would read a username like
// "1.50" as the number 1.5.
const VERBATIM = new Set(['token', 'username', 'userId']);

/** The router's search parser, with the email links' keys kept exactly as written. */
export function parseSearch(searchStr: string): Record<string, unknown> {
  const search: Record<string, unknown> = defaultParseSearch(searchStr);
  new URLSearchParams(searchStr).forEach((value, key) => {
    if (VERBATIM.has(key)) search[key] = value;
  });
  return search;
}

/** The router's search writer, the inverse of `parseSearch`. */
export function stringifySearch(search: Record<string, unknown>): string {
  const rest: Record<string, unknown> = {};
  const verbatim: [string, string][] = [];
  for (const [key, value] of Object.entries(search)) {
    if (VERBATIM.has(key) && typeof value === 'string') verbatim.push([key, value]);
    else rest[key] = value;
  }
  const params = new URLSearchParams(defaultStringifySearch(rest));
  for (const [key, value] of verbatim) params.set(key, value);
  const result = params.toString();
  return result ? `?${result}` : '';
}
